import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  images: [], // Array to store image data
  collections: [],
  currentCollection: 0,
  loading: false,
  error: null,
  musics: [],
  total: 0,
};

const imagesSlice = createSlice({
  name: "images",
  initialState,
  reducers: {
    // Action to set the list of images
    setImages: (state, action) => {
      state.images = action.payload;
    },
    setTotal: (state, action) => {
      state.total = action.payload;
    },
    // Action to add a new image to the list
    addImage: (state, action) => {
      state.images.push(action.payload);
    },

    setCollections: (state, action) => {
      state.collections = action.payload;
      state.currentCollection = 0;
    },

    setCurrentCollection: (state, action) => {
      state.currentCollection = action.payload;
    },
    // Action to start loading
    setLoading: (state, action) => {
      state.loading = action.payload ?? !state.loading;
    },
    // Action to set an error
    setError: (state, action) => {
      state.error = action.payload;
    },
    setMusics: (state, action) => {
      state.musics = action.payload;
    },
    // Optionally, add more actions as needed
  },
  // You can also add extraReducers if you're using thunk actions to fetch images
});

export const {
  setImages,
  addImage,
  setCollections,
  setCurrentCollection,
  setLoading,
  setError,
  setMusics,
  setTotal,
} = imagesSlice.actions;
export default imagesSlice.reducer;
